import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SourcingService } from '../../../components/procurement/sourcing/pages/sourcing/sourcing.service';
import { TabsService } from '../tabs/tabs.service';
import { Route, Router } from '@angular/router';
import { Menu } from '../../services/nav.service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {
  @Input() infoDetailsList: { key: string; value: string | number; hidden?: boolean ; badge?: boolean;}[] = [];
  @Input() isExpanded: boolean = true;
  @Input() reminderOn: boolean = false;
  @Output() inputValueEmit:EventEmitter<boolean> = new EventEmitter();
  showDetailInfo: boolean = false;

  constructor(
     public service: SourcingService, public tabsService : TabsService, public router : Router , 
  ) { }

  ngOnInit(): void {
  }
  onClick() {
    this.isExpanded = !this.isExpanded;
    this.inputValueEmit.emit(this.isExpanded);
  }
  onsourcingbatchclick(data: any){
     let newdata = data
      this.showDetailInfo = true;
      let url
      this.service.sourcingId = newdata?.sourcingId;
      url = `procurement/sourcing/sourcing-batch-overview/${newdata?.sourcingId}`;
      const item: Menu = { path: url, icon: '', title: newdata?.sourcingNo, type: 'link', id: newdata?.sourcingId }
      this.tabsService.addTab(item);
      this.router.navigateByUrl(url);
      this.service.activeTab.next(1);
  }


}
